module.exports = __webpack_public_path__ + "static/media/Calleb Osei.8d5e530f.jpeg";